import { NetworkType, getNetworkTypeIfExists } from 'abis/set/sets'
import { atom, useSetAtom } from 'jotai'
import { useEffect } from 'react'
import { Address } from 'viem'
import { useAccount } from 'wagmi'

export const userAccountAtom = atom<Address | undefined>(undefined)
export const chainIdAtom = atom<NetworkType | undefined>(undefined)

export const AccountProvider = () => {
  const { address, isConnected, chain } = useAccount()

  const setUserAddress = useSetAtom(userAccountAtom)
  const setNetwork = useSetAtom(chainIdAtom)

  useEffect(() => {
    const networkType = getNetworkTypeIfExists(chain?.id ?? -1)
    setNetwork(networkType)
  }, [chain])

  useEffect(() => {
    setUserAddress(address)
  }, [address, isConnected])
  return <></>
}
